import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
export const useMenuReset = (setState, isVisible) => {
  const $ = _c(6);
  const pathname = usePathname();
  const resetFn = useRef(setState);
  let t0;
  let t1;
  if ($[0] !== isVisible) {
    t0 = () => {
      if (!isVisible) {
        resetFn.current();
      }
    };
    t1 = [resetFn, isVisible];
    $[0] = isVisible;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      resetFn.current();
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== pathname) {
    t3 = [resetFn, pathname];
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
};